import { formatInTimeZone } from 'date-fns-tz'

import { useDateStore } from '@/components/DateInput'
import { DisruptionLogCode, Log } from '@/types/logs'
import { useNotification } from '@/ui/Notification'
import { useGetAreas } from '@/modules/Areas'
import { useNavigate } from 'react-router-dom'

export const useShareLog = (log: Log) => {
    const navigate = useNavigate()
    const { date } = useDateStore()
    const { data: areas = [] } = useGetAreas()
    const { showNotification } = useNotification()
    const isDisruptionLog =
        log.code && (Object.values(DisruptionLogCode) as string[]).includes(log.code.toLocaleLowerCase())

    const allRoutes = areas.flatMap((area) =>
        area.workstations.flatMap((workstation) => workstation.routes.map((route) => route.route))
    )

    const createUrl = () => {
        const url = new URL(`${window.location.origin}/logs/shared`)
        url.searchParams.set('sharedLogId', log.id)
        if (log.timestamp) {
            url.searchParams.set('date', new Date(log.timestamp).toISOString().split('T')[0])
        } else {
            url.searchParams.set('date', formatInTimeZone(date, 'UTC', 'yyyy-MM-dd'))
        }

        // Set routes
        if (log.routes && log.routes.length > 0 && !isDisruptionLog) {
            url.searchParams.set('route', log.routes[0])
        }

        if (log.routes && log.routes.length > 0 && isDisruptionLog) {
            const route = log.routes.find((route) => allRoutes.some((item) => item === route))
            route && url.searchParams.set('route', route)
        }
        return url
    }

    const handleShareLog = () => {
        navigator.clipboard
            .writeText(createUrl().toString())
            .then(() => {
                showNotification({
                    message: 'Record link copied to clipboard',
                })
            })
            .catch(() => {
                showNotification({
                    message: 'Failed to copy link to clipboard',
                })
            })
    }

    const navToSharedLog = () => {
        const url = createUrl()
        navigate({
            pathname: url.pathname,
            search: url.search,
        })
    }

    return { handleShareLog, navToSharedLog }
}
